import {useState} from 'react';
import {IconButton} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMagnifyingGlass} from '@fortawesome/pro-duotone-svg-icons';
import {useTheme} from "@mui/material/styles";
import SearchPopover from "@/src/components/main-site/_partials/header/search/search-popover";

const SearchButton = () => {
    const [searchAnchorEl, setSearchAnchorEl] = useState<null | HTMLElement>(null);
    const theme = useTheme();
    return (
        <>
            <IconButton
                aria-describedby="popover-search"
                onClick={(event) => setSearchAnchorEl(event.currentTarget)}
                color="inherit"
                sx={{
                    padding: 0,
                    ml: .5,
                    mb: .25
                }}
            >
                <FontAwesomeIcon icon={faMagnifyingGlass} size={'xs'} color={theme.palette.primary.main}/>
            </IconButton>
            <SearchPopover elAnchor={searchAnchorEl} setElAnchor={setSearchAnchorEl}/>
        </>
    );
};

export default SearchButton;
